import { getBrowserFingerprint } from '@patsnap-utils/browser-fingerprint';
import { InitCookie } from '@patsnap/init-cookie';

let fingerprint = '';

export async function getFingerprint(): Promise<string> {
    if (!fingerprint) {
        // 有显示使用InitCookie的游客版id,这个是可以通过该cookie改值的,方便测试
        fingerprint = InitCookie.getVisitorId() || await getBrowserFingerprint();
    }
    return fingerprint;
}
